//@ts-nocheck
import { authReducer } from "./Auth/Reducer";
import { legacy_createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { orderReducer } from "./Order/Reducer";
import { customerProductReducer } from "./Product/Reducer";
import { cartReducer } from "./Cart/Reducer";
import { adminOrderReducer } from "./Admin/Order/Reducer";
import { adminUserReducer } from "./Admin/User/Reducer";

const rootReducers = combineReducers({
  auth: authReducer,
  products: customerProductReducer,
  cart: cartReducer,
  order: orderReducer,
  adminOrder: adminOrderReducer,
  adminUser: adminUserReducer,
});

export const store = legacy_createStore(rootReducers, applyMiddleware(thunk));
